// 안전위반통보서 위반내역 기준 (PPT 슬라이드 11)
// - Write.vue 의 위반내역/세부항목 셀렉트와 PopupViolationCriteria(발부기준 팝업)가 공유한다
export const 위반유형목록 = [
  {
    유형: "불안전한 행동",
    항목: [
      "안전보호구(안전모, 안전대 등) 미착용 또는 부적정 착용 (안전대 고리 미체결)",
      "추락위험 행동 : 안전대 미체결 상태로 고소작업, 사다리 최상단 작업 등",
      "끼임위험 행동 : 방호덮개 개방상태 회전체 접근, 가동 중 설비 촉수 등",
      "중량물 작업시 : 인양물 하부 출입, 신호수 미배치, 줄걸이 불량, 작업반경 내 접근금지",
      "화기작업시 : 화기감시자 미배치, 주변 가연물 사전 제거 미실시 등",
      "장비 작업시 : 장비(지게차 등) 작업반경 임의 출입, 신호수 미배치",
    ],
  },
  {
    유형: "불안전한 상태",
    항목: [
      "안전시설물 미설치(개구부 덮개 미설치 포함) 및 해체 후 방치",
      "설비방호조치 불량 : 회전체 덮개 탈락 방치, 인터록 임의 해제 등",
      "작업발판 비계상태 불량 : 작업발판 고정 불량, 승강통로 미확보 등",
    ],
  },
  {
    유형: "작업허가·절차 위반",
    항목: [
      "안전작업허가 또는 일 안전작업허가 승인 前 작업 개시 / 허가된 작업범위 外 작업 실시 등",
      "DKS 안전기준 미준수 (ILS 및 LOTO기준, 작업계획서, 밀폐공간작업 등)",
    ],
  },
  {
    유형: "기타사항",
    항목: [
      "DKS 시정조치요청 및 안전 관련 지시사항 불이행 또는 시정조치 관련 미조치 건 다수 방치",
      "DKS 시설물 파손으로 인해 문제사항 발생 시",
      "안전환경 기본수칙 위반 (지정장소 外 흡연, 과속, 폐기물 무단 투기·배출 등)",
    ],
  },
];

// 등급별 감점 점수
export const 등급점수 = { 경미: -1, 주의: -2, 심각: -3 };

// 등급 뱃지 색상 (목록 colorBox / 상세 팝업 공용)
export const 등급색상 = { 경미: "#00CFE8", 주의: "#FF9F43", 심각: "#EA5455" };
